<template>
  <Card class="ts">
    <div class="ts__show">
      <Tabs
        v-model="type"
        @tab-click="handleTabClick"
      >
        <TabPane
          v-for="item in tabs"
          :key="item.key"
          :label="item.name"
          :name="item.key"
        />
      </Tabs>
    </div>

    <Table
      v-loading="tableLoading"
      class="ts__table"
      border
      :data="tableData"
      :header-cell-style="tableHeaderStyle"
    >
      <TableColumn
        label="日期"
        prop="date"
        width="100px"
      />
      <TableColumn
        v-for="item in tableColumns"
        :key="item.prop"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
        align="right"
      >
        <template slot-scope="scope">
          <TableCell :dataSource="scope" />
        </template>
      </TableColumn>
    </Table>

    <div
      v-loading="rateLoading"
      class="ts__rate"
    >
      消耗波动占比：{{ rate }}%
      <Tooltip content="消耗Top10的波动，占大盘波动的比例">
        <i class="el-icon-question ts__rate--icon" />
      </Tooltip>
    </div>
  </Card>
</template>

<script>
import { Card, Tabs, TabPane, Table, TableColumn, Tooltip } from 'element-ui';

import columns from './columns';
import Request from '@/core/QuRequest';
import { createTableData } from '../utils/formatData';
import TableCell from '../components/TableCell';

const req = new Request();

export default {
  components: {
    Card,
    Tabs,
    TabPane,
    Table,
    TableColumn,
    Tooltip,

    TableCell,
  },

  props: {
    date: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      type: 'agent',
      tabs: [
        {
          key: 'agent',
          name: 'TOP10代理商汇总',
        },
        {
          key: 'product',
          name: 'TOP10产品汇总',
        },
        {
          key: 'product3',
          name: 'TOP10产品互动页',
        },
        {
          key: 'product1',
          name: 'TOP10产品列表页',
        },
        {
          key: 'product2',
          name: 'TOP10产品详情页',
        },
      ],
      tableData: [],
      tableColumns: columns,
      tableLoading: false,
      rate: 0,
      rateLoading: false,
    };
  },

  watch: {
    date() {
      this.updateData();
    },
  },

  created() {
    this.updateData();
  },

  methods: {
    updateData() {
      this.volatilityTopSummary();
      this.volatilitytopSummaryRate();
    },

    async volatilityTopSummary() {
      this.tableLoading = true;
      try {
        const params = {
          date: this.date[0].format('YYYY-MM-DD'),
          compare_date: this.date[1].format('YYYY-MM-DD'),
          type: this.type,
        };
        const res = await req.send(
          req.Apis.sales.report.volatilityTopSummary,
          params,
        );
        this.tableLoading = false;

        if (res && res.code === 200) {
          const data = createTableData(res.data);
          this.tableData = data;
        }
      } catch (err) {
        this.tableLoading = false;
        this.$message.error(err.message);
      }
    },

    async volatilitytopSummaryRate() {
      this.rateLoading = true;
      try {
        const params = {
          date: this.date[0].format('YYYY-MM-DD'),
          compare_date: this.date[1].format('YYYY-MM-DD'),
          type: this.type,
        };
        const res = await req.send(
          req.Apis.sales.report.volatilitytopSummaryRate,
          params,
        );
        this.rateLoading = false;

        if (res && res.code === 200) {
          this.rate = res.data.rate;
        }
      } catch (err) {
        this.rateLoading = false;
        this.$message.error(err.message);
      }
    },

    handleTabClick() {
      this.updateData();
    },

    tableHeaderStyle({ rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #F2F9FF';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.ts {
  margin-top: 24px;

  &__show {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__table {
    margin-top: 24px;
  }

  &__rate {
    font-size: 14px;
    font-weight: 400;
    color: rgba(48, 49, 51, 1);
    margin-top: 24px;

    &--icon {
      margin-left: 6px;
      cursor: pointer;
    }
  }
}
</style>